import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'xui-mat-fax-card',
    templateUrl: './app-mat-fax-card.component.html',
    styleUrls: ['./app-mat-fax-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule]
})
export class AppMatFaxCardComponent {
    readonly number = input<string | undefined>();

    get faxNumber(): string {
        const faxNumber = this.number();
        return (faxNumber && faxNumber.length) ? faxNumber : 'Not specified';
    }
}
